/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogTitleComponent } from '@ng-falcon/dialog/dialog-title/dialog-title.component';

@Component({
  selector: 'ut-reject-article-modal',
  standalone: true,
  imports: [FormsModule, MatDialogModule, DialogTitleComponent],
  template: `
    <ngf-dialog-title mat-dialog-title>Confirm Reject</ngf-dialog-title>
    <mat-dialog-content>
      <p>Please provide a reason for rejecting "{{ article.title }}".</p>
      <label for="rejectReason">Rejection reason</label>
      <input
        id="rejectReason"
        class="form-control"
        type="text"
        placeholder="e.g. Off-topic, low quality"
        [(ngModel)]="reason"
      />
    </mat-dialog-content>
    <mat-dialog-actions>
      <button class="modal-action-btn" type="button" (click)="cancel()">Cancel</button>
      <button
        class="modal-action-btn modal-action-btn--primary"
        type="button"
        [disabled]="!reason.trim()"
        (click)="confirm()">
        Reject
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content p {
      margin-bottom: 1rem;
    }

    mat-dialog-content input {
      width: 100%;
    }

    mat-dialog-actions {
      gap: 1rem;
    }

    .modal-action-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0.8rem 2rem;
      border-radius: 0.8rem;
      font-size: 1.4rem;
      font-weight: 600;
      cursor: pointer;
      border: 0.1rem solid #E9EAEB;
      background-color: #f6f8f9;
      color: #697886;
      box-shadow: 0 0.1rem 0.2rem 0 rgba(10, 13, 18, 0.05);
    }

    .modal-action-btn:hover:not(:disabled) {
      background-color: #eaeef1;
    }

    .modal-action-btn--primary {
      background-color: #006680;
      border-color: #006680;
      color: #fff;
    }

    .modal-action-btn--primary:hover:not(:disabled) {
      background-color: #005570;
      border-color: #005570;
    }

    .modal-action-btn--primary:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `],
})
export class RejectArticleModalComponent {
  reason = '';

  constructor(
    private dialogRef: MatDialogRef<RejectArticleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public article: any,
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(this.reason);
  }
}
